var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgImageFilled = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50391 2.00006C3.12319 2.00006 2.00391 3.11935 2.00391 4.50006V19.5001C2.00391 20.8808 3.12319 22.0001 4.50391 22.0001H19.5039C20.8846 22.0001 22.0039 20.8808 22.0039 19.5001V4.50006C22.0039 3.11935 20.8846 2.00006 19.5039 2.00006H4.50391ZM8.64392 13.2871C8.4023 12.8884 7.82504 12.885 7.57876 13.2808L4.82188 17.7115C4.56283 18.1278 4.8622 18.6667 5.35254 18.6667H18.7898C19.25 18.6667 19.5524 18.1862 19.3533 17.7713L15.3684 9.46937C15.1378 8.98893 14.4502 8.999 14.2338 9.48599L10.8942 17L8.64392 13.2871Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImageFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ImageFilled.2a5ba19b6d2fb9acd95dfbf3cca2632a.svg";